import { useEffect, useState } from 'react';
import { SaveSegmentInput, segmentsService } from '../services/segmentsService';
import { Segment } from '../types/trimestersSettings.types';

export const useSegments = () => {
  const [segments, setSegments] = useState<Segment[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const loadSegments = () => {
      setIsLoading(true);
      segmentsService
        .list()
        .then((items) => {
          if (!mounted) return;
          setSegments(items);
          setError(null);
        })
        .catch((loadError) => {
          if (!mounted) return;
          setError(loadError instanceof Error ? loadError.message : 'Nao foi possivel carregar os segmentos.');
        })
        .finally(() => {
          if (!mounted) return;
          setIsLoading(false);
        });
    };

    loadSegments();
    window.addEventListener(segmentsService.changedEvent, loadSegments);

    return () => {
      mounted = false;
      window.removeEventListener(segmentsService.changedEvent, loadSegments);
    };
  }, []);

  const saveSegment = async (input: SaveSegmentInput & { id?: string }) => {
    const segmentInput: SaveSegmentInput = {
      name: input.name,
      ageStart: input.ageStart,
      ageEnd: input.ageEnd,
      active: input.active,
    };

    await (input.id ? segmentsService.update(input.id, segmentInput) : segmentsService.create(segmentInput));
    const items = await segmentsService.list();
    setSegments(items);
  };

  const removeSegment = async (segmentId: string) => {
    await segmentsService.remove(segmentId);
    const items = await segmentsService.list();
    setSegments(items);
  };

  return { segments, isLoading, error, saveSegment, removeSegment };
};
